import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import IMAGE from "../../assets/images/login-background-image.png";
import LOGO from "../../assets/images/accupose-logo.png";

// ================================|| AUTH WRAPPER ||================================ //

export default function AuthWrapper({ children }) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        backgroundImage: `url(${IMAGE})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(0,0,0,0.45)',
        },
      }}
    >
      <Card
        sx={{
          position: 'relative',
          zIndex: 1,
          width: 480,
          maxWidth: '80vw',
          height: 520,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '6px',
          boxShadow: '0 8px 40px rgba(0,0,0,0.35)',
          border: 'none',
        }}
      >
        {/* ---- Fixed logo + name — never scrolls ---- */}
        <Box
          sx={{
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            pt: 2,
            pb: 1,
          }}
        >
          <Box
            component="img"
            src={LOGO}
            alt="Accupose Logo"
            sx={{ height: 52, width: 52, objectFit: 'cover', display: 'block' }}
          />
          <Typography
            variant="h3"
            fontWeight={550}
            sx={{ letterSpacing: 1, color: 'primary.main', lineHeight: 1 }}
          >
            Accupose
          </Typography>
        </Box>

        {/* ---- Scrollable form content ---- */}
        <CardContent
          sx={{
            flex: 1,
            overflowY: 'auto',
            px: 4,
            py: 2.5,
            '&:last-child': { pb: 3 },
            '&::-webkit-scrollbar': { width: 4 },
            '&::-webkit-scrollbar-track': { background: 'transparent' },
            '&::-webkit-scrollbar-thumb': {
              background: '#ddd',
              borderRadius: 2,
            },
          }}
        >
          {children}
        </CardContent>
      </Card>
    </Box>
  );
}